import React, { useState } from 'react';
import './scss/CreateWorkspace.scss';
import { useDispatch } from 'react-redux';
import { showSuccess, showError } from '../../utils/snackbarHelpers';
import { useNavigate } from 'react-router-dom';
import ZoobbeSelect from '../Global/ZoobbeSelect';
import { fetchWorkspaces } from '../../redux/Slices/workspaceSlice';
import { closeModal } from '../../redux/Slices/modalSlice';
import { config } from '../../config';

const CreateWorkspace = () => {
  const [workspaceName, setWorkspaceName] = useState('');
  const [workspaceType, setWorkspaceType] = useState('engineering-it');
  const [workspaceDescription, setWorkspaceDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};

    if (!workspaceName.trim()) {
      newErrors.name = '👋 Workspace name is required';
    } else if (workspaceName.trim().length < 2) {
      newErrors.name = 'Workspace name must be at least 2 characters';
    } else if (workspaceName.trim().length > 50) {
      newErrors.name = 'Workspace name must be less than 50 characters';
    }

    if (workspaceDescription.trim().length > 200) {
      newErrors.description = 'Description must be less than 200 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreateWorkspace = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    const workspaceData = {
      name: workspaceName.trim(),
      type: workspaceType,
      description: workspaceDescription.trim(),
    };

    try {
      const response = await fetch(`${config.API_URI}/v1/workspaces/me`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(workspaceData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create workspace');
      }

      const data = await response.json();
      showSuccess(dispatch, data.message);
      dispatch(closeModal());
      dispatch(fetchWorkspaces());
      navigate(`${data.workspace.shortLink}/boards`);
    } catch (error) {
      showError(dispatch, `Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const workspaceTypes = [
    { value: 'engineering-it', label: 'Engineering & IT' },
    { value: 'education', label: 'Education' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'design', label: 'Design' },
    { value: 'business', label: 'Business' },
    { value: 'personal', label: 'Personal' },
  ];

  const handleWorkspaceTypeSelect = (type) => {
    setWorkspaceType(type.value);
  };

  return (
    <div className='workspace-container'>
      <div className="create-workspace-form">
        <h1>Let's Build a Workspace</h1>
        <p>Boost your productivity by keeping all boards in one place.</p>

        <form onSubmit={handleCreateWorkspace}>
          {/* Workspace Name */}
          <div className="group">
            <h3>Workspace Name*</h3>
            <input
              type="text"
              id="workspace-name"
              value={workspaceName}
              onChange={(e) => setWorkspaceName(e.target.value)}
              placeholder="Enter Workspace Name"
              className={errors.name ? 'error' : ''}
              maxLength={50}
            />
            {errors.name && (
              <p className="error-message">{errors.name}</p>
            )}
          </div>

          {/* Workspace Type */}
          <div className="group">
            <h3>Workspace Type*</h3>
            <ZoobbeSelect
              options={workspaceTypes}
              defaultSelectedOption={0}
              onSelect={handleWorkspaceTypeSelect}
            />
          </div>

          {/* Workspace Description */}
          <div className="group">
            <h3>
              Workspace Description <span>(Optional)</span>
            </h3>
            <textarea
              id="workspace-description"
              value={workspaceDescription}
              onChange={(e) => setWorkspaceDescription(e.target.value)}
              placeholder="Describe your workspace (optional)"
              className={errors.description ? 'error' : ''}
              maxLength={200}
            />
            {errors.description && (
              <p className="error-message">{errors.description}</p>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={loading ? 'disabled' : ''}
          >
            {loading ? 'Creating...' : 'Create Workspace'}
          </button>
        </form>
      </div>
      {/* Right Side Preview */}
      <div className="workspace-right-content">
        {/* <div className="workspace-preview-card">
          <h2>{workspaceName || "Your Workspace"}</h2>
          <p>{workspaceDescription || "Workspace description will appear here."}</p>
          <span className="tag">{workspaceTypes.find(t => t.value === workspaceType)?.label}</span>
        </div> */}
      </div>
    </div>
  );
};

export default CreateWorkspace;
